import React from 'react';
export function CreatorQuote() {
  return null;
}